module.exports = (s) => {
  return [
    {
      name: '渠道包名称',
      value: 'package_name',
      align: 'center',
      width: '200px',
      overflow: false,
    },
    {
      name: '渠道包 id',
      value: 'channel_package_id',
      align: 'center',
      overflow: false,
    },
    {
      name: '版本名',
      value: 'version_name',
      align: 'center',
      overflow: false,
    },
    {
      name: '版本号',
      value: 'version_code',
      align: 'center',
      overflow: false,
    },
    {
      name: '状态',
      value: 'system_status',
      align: 'center',
      format: (row, cell, cellValue) => {
        const type = {
          'CHANNEL_PACKAGE_STATUS_PASSED': '审核通过',
          'CHANNEL_PACKAGE_STATUS_REVIEWING': '审核中',
          'CHANNEL_PACKAGE_STATUS_DENIED': '审核拒绝',
          'CHANNEL_PACKAGE_STATUS_DENIED_AGAIN': '审核拒绝，使用更新前的数据',
          'CHANNEL_PACKAGE_STATUS_REVIEWING_AGAIN': '再次审核中',
          'CHANNEL_PACKAGE_STATUS_ON_OFFLINE': '下线中',
          'CHANNEL_PACKAGE_STATUS_OFFLINE': '下线',
          'CHANNEL_PACKAGE_STATUS_DRAFT': '草稿',
        };
        return type[cellValue];
      },
    },
    {
      name: '创建时间',
      value: 'created_time',
      align: 'center',
    },
    {
      name: '更新时间',
      value: 'updated_time',
      align: 'center',
    },
  ];
};
